/** Scale the ratio base */
export var BASE_SCALE_RATIO = 1;
/** The maximum zoom ratio when the mouse zooms in, adjustable */
export var WHEEL_MAX_SCALE_RATIO = 1;